import axios from "axios";

const API_URL = "/api/unit_filters";

export const getUnitFilters = () => axios.get(API_URL);
export const getUnitFilter = (id) => axios.get(`${API_URL}/${id}`);
export const createUnitFilter = (data) => axios.post(API_URL, data);
export const updateUnitFilter = (id, data) => axios.put(`${API_URL}/${id}`, data);
export const deleteUnitFilter = (id) => axios.delete(`${API_URL}/${id}`);
